export default __webpack_public_path__ + "static/media/warning-image.4f342105.png";